import React from 'react';
import { P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import ConsignmentSummaryParcels from '../panels/consignments/ConsignmentSummaryParcels';
import { GenerateConsignmentFromItem } from '../panels/consignments/GenerateConsignmentFromItem';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { getDisplayDimensions } from '~/apps/smartsend/lib/parcels/itemView';

type props = {
  item: SmartSendItemApiModel;
};

const SingleItemOptionsReverted: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const item = props.item;

  return (
    <>
      <P2GText>
        {t('SINGLE_ITEM_ONE_BOX_INTRO_TEXT', {
          defaultValue:
            'Everything will be sent in a single box on one label. The parcel arrangement you have set up, including anything you edited per parcel, will be discarded.'
        })}
      </P2GText>
      <ConsignmentSummaryParcels
        consignment={GenerateConsignmentFromItem(
          item,
          {
            Weight: getDisplayDimensions(item).Weight
          },
          1
        )}
        currencyCode={item.CurrencyCode}
      >
        <P2GText variant="caption">
          {t('SINGLE_ITEM_ONE_BOX_REVERTED_PARCEL', {
            defaultValue: 'Your consignment will be reverted back to:'
          })}
        </P2GText>
      </ConsignmentSummaryParcels>
    </>
  );
};

export default SingleItemOptionsReverted;
